<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
          <!-- <div>
            <v-spacer></v-spacer>
            <h3
              style="text-align:center"
            >Total Peritos Activos: {{ listStats.peritos_total }}
            </h3>

            <v-progress-linear
              v-model="skill"
              color="teal lighten-2"
              height="20"
            >
              <template v-slot:default="{ value }">
                <strong>Peritos con solicitud {{ Math.ceil(value) }}%</strong>
              </template>
            </v-progress-linear>
          </div> -->
          <br>
        <v-card>
          <v-toolbar color="#676767" dark dense>
            <v-btn v-for="(role, key) in currentUser.roles" v-if="role.id < 4" icon to="/users">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-toolbar-title class="d-none d-sm-flex"><b>Peritos</b></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model.trim="full_name"
              append-icon="mdi-magnify"
              label="Buscar Perito"
              single-line
              hide-details
              clearable
              @click:append="getPeriodos"
            ></v-text-field>

            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <Formsolicitud :editedIndex="this.editedIndex" :editedItem="this.editedItem" @close="close"/>
            </v-dialog>

          </v-toolbar>

          <v-data-table
            dense
            :headers="headers"
            :items="listPeritos"
            item-key="user"
            class="elevation-1"
            :loading="loading"
            hide-default-footer
            :items-per-page="per_page_table"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-select
                  label="Periodos"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  class="mt-7"
                  :items="listPeriodos"
                  v-model="periodo"
                  @change="getPeritos"
                ></v-select>
                <v-spacer></v-spacer>
                <v-checkbox
                  class="mt-7"
                  v-model="checkbox"
                  label="Peritos sin datos generales"
                ></v-checkbox>
                <v-spacer></v-spacer>
                <v-select
                  :disabled="checkbox"
                  label="Status"
                  class="mt-7"
                  :items="itemStatus"
                  item-text="text"
                  item-value="id"
                  v-model="statusSolicitud"
                  @change="getPeritos"
                  clearable
                ></v-select>
              </v-toolbar>
              <v-toolbar flat color="white">
                <v-autocomplete
                  :disabled="checkbox"
                  class="mt-2"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listPartidos"
                  v-model="partido"
                  label="Partidos Judiciales"
                  @change="getPeritos"
                  clearable
                ></v-autocomplete>
              </v-toolbar>
              <v-toolbar flat color="white">
                <v-autocomplete
                  :disabled="checkbox"
                  class="mt-2"
                  return-object
                  item-text="nombre"
                  item-value="id"
                  :items="listEspecialidad"
                  v-model="materia"
                  label="Materia"
                  @change="getPeritos"
                  clearable
                ></v-autocomplete>
              </v-toolbar>
            </template>
            <template v-slot:item.ncompleto="{ item }">
              {{item.primer_apellido}} {{item.segundo_apellido}} {{item.nombre}}
            </template>
             <template v-slot:item.informes_data="{ item }">
               <!-- {{item.solicitudes[0].informes_status }} -->
               <div v-if="item.solicitudes !== undefined && item.solicitudes.length !== 0 ">
                <v-chip
                  class="ma-2"
                  small
                  :color='colors[item.solicitudes[0].informes_status[0]]'
                >
                  1
                </v-chip>
                <v-chip
                  class="ma-2"
                  small
                  :color='colors[item.solicitudes[0].informes_status[1]]'
                >
                  2
                </v-chip>
                <v-chip
                  class="ma-2"
                  small
                  :color='colors[item.solicitudes[0].informes_status[2]]'
                >
                  3
                </v-chip>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn v-if="item.solicitudes && item.solicitudes.length > 0" text @click="mostrarSolicitudes(item)" color="blue">
                <v-icon dark>mdi-eye</v-icon>
              </v-btn>
              <!-- <div > -->
                <v-tooltip top v-for="(role, key) in currentUser.roles" v-if="item.solicitudes && item.solicitudes.length > 0 && role.id <= 2 && periodoActivo.id == periodo.id">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" @click="refrendarSolicitud(item)" color="yellow darken-2">
                      <v-icon dark>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Refrendar/Reincorporar</span>
                </v-tooltip>
              <!-- </div> -->
              <v-icon v-for="(role, key) in currentUser.roles" v-if="!item.solicitudes && periodoActivo.id == periodo.id && role.id < 4" class="mr-2" @click="btnAddSolicitud(item)" color="orange">
                mdi-plus
              </v-icon>
              <!-- Botón enviar enlace de reset de contraseña -->
              <v-tooltip top v-if="roleUser <= 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text v-bind="attrs" v-on="on" @click="openResetDialog(item)" :color="item.reset_sent_at ? 'green' : 'grey'">
                    <v-icon dark>{{ item.reset_sent_at ? 'mdi-email-check' : 'mdi-lock-reset' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.reset_sent_at ? 'Reenviar enlace de contraseña' : 'Enviar enlace de contraseña' }}</span>
              </v-tooltip>
              <v-btn text color="red" v-if="roleUser < 3">
                <v-icon dark>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
            ></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Dialog para enviar enlace de reset de contraseña -->
    <v-dialog v-model="resetDialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="headline">
          Enviar enlace de restablecimiento
        </v-card-title>
        <v-card-text>
          <p class="body-2 mb-3">
            Se enviará un enlace de restablecimiento de contraseña al siguiente correo para
            <strong>{{ resetPerito ? resetPerito.nombre + ' ' + resetPerito.primer_apellido : '' }}</strong>:
          </p>
          <v-text-field
            v-model="resetEmail"
            label="Correo de destino"
            outlined
            :rules="emailRules"
            prepend-inner-icon="mdi-email"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="resetDialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="resetLoading" @click="sendResetLink" :disabled="!resetEmail">
            Enviar enlace
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Formsolicitud from '@/components/Formsolicitud.vue'
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');

export default {
  components:{
    Formsolicitud
  },
  data() {
    return {
      pagination: {
        current: 1,
        total: 0
      },
      skill: 0,
      per_page_table: 5,
      filtros:[],
      periodo_stats:'',
      newPerido:'',
      oldPeriodo:'',
      valid: true,
      dialog: false,
      loading:false,
      headers: [
        { text: 'Folio', value: 'folio', sortable: true },
        { text: 'Nombre', value: 'ncompleto', sortable: false },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Email Contacto', value: 'email_contacto', sortable: true },
        { text: 'Informes', value: 'informes_data', sortable: false },
        // { text: 'Perito Activo', value: 'status', sortable: true, align: 'center'  },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center' }
      ],
      statusSolicitud:'',
      checkbox: false,
      itemStatus: [
        { text: "Activos", id:1 },
        { text: "Inactivos", id:2 }
      ],
      partido:'',
      materia:'',
      full_name:'',
      listPeritos: [],
      editedIndex: -1,
      // activo: true,
      telefono:'',
      telefonos:[],
      domicilio:{
        calle:'',
        no_ext:'',
        no_int: '',
        cp: "",
        colonia: '',
        municipio: '',
        estado: '',
      },
      domicilios:[],
      carrera:'',
      carreras:[],
      especializacion:'',
      especializaciones:[],
      estudio:'',
      estudios:[],
      periodo: '',
      editedItem: {
        primer_apellido:'',
        segundo_apellido:'',
        nombre:'',
        email:'',
        fec_nacimiento:'',
        nacionalidad:'',
      },
      defaultItem: {
        perito_data:[],
        primer_apellido:'',
        segundo_apellido:'',
        nombre:'',
        email:'',
        fec_nacimiento:'',
        nacionalidad:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      ],
      'colors': [
        '',
        '',
        'yellow',
        'green',
        'orange'
      ],
      // Reset password dialog
      resetDialog: false,
      resetPerito: null,
      resetEmail: '',
      resetLoading: false,
    }
  },
  computed: {
    ...mapGetters([
      "permisosList", "currentUser", "listPeriodos", "listEspecialidad", "listPartidos", "listStats", "roleUser"
    ])
  },
  watch: {
    full_name: function (val) {
      this.statusSolicitud = "";
      this.partido = "";
      this.materia = "";
      this.pagination.current = 1;
      if (!val) this.getPeritos();
    },
    checkbox: function (val) {
      if(val){
        this.statusSolicitud = "";
        this.partido = "";
        this.materia = "";
        this.pagination.current = 1;
      }
      this.full_name = "";
      this.getPeritos();
    },
    periodo(value){
      this.perido_stats = value;
      // console.log(this.perido_stats);
    },
  },
  mounted() {
    this.getEspecialidades();
    this.getPeriodos();
    this.getPartidos();
    // this.getStats();
  },
  methods: {
    btnAddSolicitud (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close (item) {
      this.dialog = false
      this.getPeritos();
    },

    mostrarSolicitudes(item){
      let userLogged =  JSON.parse(localStorage.getItem("user"))
      userLogged.perito_id = item.id
      userLogged.periodo_id = this.periodo.id
      localStorage.setItem("user", JSON.stringify(userLogged));
      this.$router.push('/perito/show')
    },
    refrendarSolicitud(item){
      if (item.segundo_apellido != null) {
        var name = item.nombre+' '+item.primer_apellido+' '+item.segundo_apellido
      } else {
        var name = item.nombre+' '+item.primer_apellido
      }
      var title = item.solicitudes[0].habilitado==1 ? '¿Desea Refrendar Solicitud a '+name+'?' : '¿Desea Reincorporar Solicitud a '+name+'?'
      // console.log(item);
      this.$swal({
        // title: '¿Desea Refrendar/Reincorporar Solicitud a '+name+'?',
        title: title,
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
      //console.log(item);
        var perito_id = item.id
        this.$store.dispatch("GET_REFRENDO",  { url: "/perito/"+perito_id+"/refrendo"})
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Se Creó Solicitud Correctamente.',
            confirmButtonText: "Aceptar"
          })
            // console.log(response.data.data);
          })
          .catch(err => {
            console.log(err.response.data.message);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: err.response.data.message,
              confirmButtonText: "Aceptar"
            });
            this.loading = false;
            this.close()
          });
        }
      })
    },
    getPeritos() {
      this.loading = true
      this.periodo_stats = this.periodo
      this.filtros = {
        checkbox: this.checkbox,
        full_name: this.full_name,
        periodo_id: this.periodo ? this.periodo.id : undefined,
        especialidad_id: this.materia ? this.materia.id : undefined,
        status: this.statusSolicitud,
        partido_judicial_id: this.partido ? this.partido.id : undefined
      }
      this.$store.dispatch("GET_PERITOS", { url:  "peritos?page=" + this.pagination.current, data:this.filtros  }).then(response=>{
        this.pagination.current = response.data.data.peritos.current_page;
        this.pagination.total = response.data.data.peritos.last_page;
        this.per_page_table = response.data.data.peritos.per_page;
        this.listPeritos = response.data.data.peritos.data;
        this.loading = false
      });
      this.getStats();
    },
    onPageChange() {
      this.getPeritos();
    },
    getEspecialidades() {
      this.$store.dispatch("GET_ESPECIALIDADES",  { url: "especialidades" } ).then(response => {
          // this.listEspecialidades = response.data.data.especialidades;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPeriodos() {
      this.$store.dispatch("GET_PERIODOS",  { url: "periodos" } ).then(response => {
        this.listPeriodos.forEach(element => {
          if (element.activo == 1) {
            this.periodoActivo = element
            this.periodo = element
          }
        });
        this.getPeritos();
      })
      .catch(err => {
        console.log(err);
      });
    },
    getPartidos() {
      this.$store.dispatch("GET_PARTIDOS",  { url: "partidos-judiciales" } ).then(response => {
          // this.listPartidos = response.data.data.partidos_judiciales;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStats() {
      this.stats = {
        periodo_id: this.periodo_stats.id,
      }
      this.$store.dispatch("GET_STATS",  { url: "/peritos/stats", data:this.stats })
      .then(response => {
          // console.log(response.data.data);
          this.skill = (response.data.data.peritos_seleccionados*100)/response.data.data.peritos_total
        })
        .catch(err => {
          console.log(err);
        });
    },
    // ---- Reset Password ----
    openResetDialog(item) {
      this.resetPerito = item;
      this.resetEmail = item.email_contacto || '';
      this.resetDialog = true;
    },
    sendResetLink() {
      this.resetLoading = true;
      this.$store.dispatch("SAVE_PERITO", {
        url: "/user/" + this.resetPerito.id + "/send-reset-link",
        data: { email: this.resetEmail }
      })
      .then(response => {
        // Marcar en la lista que ya se envió
        this.resetPerito.reset_sent_at = new Date().toISOString();
        this.resetDialog = false;
        Swal.fire({
          icon: 'success',
          title: 'Enlace enviado',
          text: 'Correo enviado correctamente.',
          confirmButtonText: "Aceptar"
        });
      })
      .catch(err => {
        const msg = err.response && err.response.data ? err.response.data.message : 'No se pudo enviar el correo.';
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
          confirmButtonText: "Aceptar"
        });
      })
      .finally(() => {
        this.resetLoading = false;
      });
    }
  }
}
</script>
